export const environment = {
    production: false,
    supabaseUrl: 'https://tpjvhqaqfgmhtyjwrpsc.supabase.co',
    supabaseKey: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InRwanZocWFxZmdtaHR5andycHNjIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODIxMTcxNDksImV4cCI6MjA5NzY5MzE0OX0.OzdYDSoLAWXuTmBzR59k_FuhGpP0AKowls9DypBfaZI',
    keycloak: {
        enabled: true,
        url: 'https://auth.staging.wewiins.fr/',
        realm: 'wewiins-moderation',
        clientId: 'moderation'
    },
    api: {
        url: 'https://staging.wewiins.fr/api'
    }
};